import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { InstagramState } from 'apps/instagram/models/interfaces'
import { recommendationsApi } from 'shared/api/requests/recommendations'
import { createAsyncAction } from 'shared/lib/redux'

export const loadPersonalizedData = createAsyncAction(
  'instagram/loadPersonalizedData',
  async () => {
    const { data } = await recommendationsApi.personalizedRecommendationsData()
    return data.data
  },
  {
    condition: (_, { getState }) => {
      return (
        !getState().instagram.personalizedData.isFetching &&
        !getState().instagram.personalizedData.isFetched
      )
    },
  },
)

export const loadPersonalizedDataReducer = (builder: ActionReducerMapBuilder<InstagramState>) => {
  builder.addCase(loadPersonalizedData.pending, (state) => {
    state.personalizedData.isFetching = true
  })
  builder.addCase(loadPersonalizedData.fulfilled, (state, action) => {
    const data = action.payload
    state.personalizedData = {
      isFetching: false,
      isFetched: true,
      niche: data.ig_niche_type,
    }
  })
  builder.addCase(loadPersonalizedData.rejected, (state) => {
    state.personalizedData.isFetching = false
  })
}
